import { gql } from '@apollo/client'

const INGREDIENT_EXPLANATIONS_QUERY = gql`
  query ingredientExplanationsQuery($id: ID!) {
    ingredientExplanations(id: $id) {
      id
      text
      originField
      ingredientId
      ingredientType
    }
  }
`

export default INGREDIENT_EXPLANATIONS_QUERY
